import { AutogenModelCustomerLookupMulticompany, AutogenRowCustomerLookupMulticompany } from "./autogen/AutogenModelCustomerLookupMulticompany";

export class ModelCustomerLookupMulticompany extends AutogenModelCustomerLookupMulticompany<RowCustomerLookupMulticompany> {
	constructor() {
		super(RowCustomerLookupMulticompany);
	}
}

export class RowCustomerLookupMulticompany extends AutogenRowCustomerLookupMulticompany {
}